import { render, staticRenderFns } from "./DepositIcons.vue?vue&type=template&id=45d1baa3&scoped=true"
import script from "./DepositIcons.vue?vue&type=script&lang=js"
export * from "./DepositIcons.vue?vue&type=script&lang=js"
import style0 from "./DepositIcons.vue?vue&type=style&index=0&id=45d1baa3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d1baa3",
  null
  
)

export default component.exports